"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var AlertFill = function AlertFill(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className),
    viewBox: "0 0 24 24",
    height: "20px",
    width: "20px"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("path", {
    fill: fill,
    d: "M23.119 20L13.772 2.15a2 2 0 00-3.543 0L.881 20a2 2 0 001.772 2.928h18.694A2 2 0 0023.119 20zM11 8.423a1 1 0 012 0v6a1 1 0 01-2 0v-6zm1.05 11.51h-.028a1.528 1.528 0 01-1.522-1.47 1.475 1.475 0 011.421-1.529l.027-.001h.028A1.527 1.527 0 0113.5 18.4c.032.814-.602 1.5-1.416 1.532l-.034.001z"
  }));
};
AlertFill.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
AlertFill.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = AlertFill;